export const MILLENNIUM_INC = "Millennium Inc.";
export const BROKERAGE = "Brokerage";
export const NEW_MILLENNIUM = "New Millennium";